/**
 * 申請完了などのメッセージで、補足行を「〇」付きで表示する（□ ではなく 〇）
 * @param {string} headline 見出し1行
 * @param {string[]} [detailLines] 補足（各行の先頭に 〇 を付与）
 */
export function applicationSuccessMessage(headline, detailLines = []) {
    if (!detailLines.length) return headline;
    const lines = detailLines.map((t) => `〇 ${t}`).join('\n');
    return `${headline}\n\n${lines}`;
}
